import React from "react"

import { createIcon } from "@chakra-ui/react"

export const ClickFunnelsIcon = createIcon({
  displayName: "ClickFunnels",
  viewBox: "0 0 300 303.11",
  path: (
    <>
      <path
        fill="#98c1da"
        d="M109.1,251.08l-41.76,29.24-17.31-12.57,17.91-53.45-4.22-5.7-57.17-.42-6.54-20.19,46.33-33.01v-7.04L.43,114.52l6.8-20.19h51.23l50.63,156.75Z"
      />
      <path
        fill="#f71835"
        d="M123.83,47.67L140.19,0h21.53l17.39,53.53,6.89,2.09,46.67-32.67,17.31,12.48-17.91,53.45,4.22,5.61,57.26.5,6.46,20.19-41.5,29.57L123.83,47.67Z"
      />
      <path
        fill="#080436"
        d="M69.06,22.54l-17.48,12.4,86.79,268.17h21.53l20.41-58.98,50.8,36.44,17.48-12.4-18.68-59.06,63.03-.34,6.8-20.11L69.06,22.54Z"
      />
    </>
  ),
})

export const ClickFunnelsMonoIcon = createIcon({
  displayName: "ClickFunnels",
  viewBox: "0 0 300 303.11",
  path: (
    <>
      <path
        fill="#000000"
        d="M109.1,251.08l-41.76,29.24-17.31-12.57,17.91-53.45-4.22-5.7-57.17-.42-6.54-20.19,46.33-33.01v-7.04L.43,114.52l6.8-20.19h51.23l50.63,156.75Z"
      />
      <path
        fill="#000000"
        d="M123.83,47.67L140.19,0h21.53l17.39,53.53,6.89,2.09,46.67-32.67,17.31,12.48-17.91,53.45,4.22,5.61,57.26.5,6.46,20.19-41.5,29.57L123.83,47.67Z"
      />
      <path
        fill="#000000"
        d="M69.06,22.54l-17.48,12.4,86.79,268.17h21.53l20.41-58.98,50.8,36.44,17.48-12.4-18.68-59.06,63.03-.34,6.8-20.11L69.06,22.54Z"
      />
    </>
  ),
})
